import { Component, OnInit, OnDestroy } from '@angular/core';
import { BankAccountService } from '../../bank-register.service';
import { ActivatedRoute } from '@angular/router';
import { BankAccount } from '../../bank-account.interface';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-bank-register-top-bar',
  templateUrl: './bank-register-top-bar.component.html',
  styleUrls: ['./bank-register-top-bar.component.scss']
})
export class BankRegisterTopBarComponent implements OnInit, OnDestroy {

  // params
  bankAccountId: number;

  // data
  bankAccount: BankAccount;

  // subscriptions
  private _bankAccountSub: Subscription;

  constructor(
    private _bankAccountSvc: BankAccountService,
    private _route: ActivatedRoute
  ) { }

  ngOnInit() {

    // get the bank account id from the query params
    const bankAccountId = this._route.snapshot.paramMap.get('bankAccountId');

    // update component bank account id and convert param from string to number
    this.bankAccountId = Number(bankAccountId);

    // subscribe to bank account data from bank account service
    this._bankAccountSub = this._bankAccountSvc.BankAccount.subscribe((bankAccount: BankAccount) => {
      if (bankAccount) {
        this.bankAccount = bankAccount;
      }
    });

    // get the bank account data if it doesnt exist
    if (!this.bankAccount || this.bankAccount.Id !== this.bankAccountId) {
      this._bankAccountSvc.getBankAccount(this.bankAccountId);
    }

  }

  ngOnDestroy() {
    this._bankAccountSub.unsubscribe();
  }

}
